import { useEffect } from "react";
import { useRouter } from "next/router";
import { gql, useQuery } from "@apollo/client";

import BlogCategoryNav from "@/components/blog/BlogCategoryNav";
import BlogGrid from "@/components/blog/BlogGrid";
import Pagination from "@/components/Pagination";
import handleStaticProps from "src/lib/handle-static-props";
import Seo from "@/components/seo";
import BlogGridPlaceholder from "@/components/blog/blog-grid-placeholder";

export async function getStaticProps() {
  const { result } = await handleStaticProps({
    pageQuery,
    variables: { page: 1 },
  });

  return result;
}

function BlogIndexPage({ pageQuery: query }) {
  const router = useRouter();
  const page = parseInt(router.query.page) || 1;
  const { data, refetch } = useQuery(query || pageQuery, {
    variables: { ...router.query, page },
  });

  useEffect(() => {
    refetch({
      variables: { ...router.query, page },
    });
  }, [page, refetch, router.query]);

  const { posts } = {
    posts: data?.allBlogPosts || data?.allBlogPostsByCategory?.posts || [],
  };

  return (
    <div className="container">
      <Seo
        title={
          data?.allBlogPostsByCategory
            ? `${data.allBlogPostsByCategory.categoryTitle} | Blog`
            : "KVRX Blog"
        }
      />
      {/* HEADER */}
      <header>
        <h1 className="px-lg-5 mt-0">
          <b>KVRX BLOG</b>
        </h1>
      </header>
      {/* CATEGORIES */}
      <BlogCategoryNav />
      {/* POSTS */}
      {data ? (
        <>
          <BlogGrid posts={posts} />
          <Pagination
            activePage={posts.page}
            maxPages={posts.pages}
            pageRangeDisplayed={3}
          />
        </>
      ) : (
        <BlogGridPlaceholder count={12} />
      )}
    </div>
  );
}

export default BlogIndexPage;

const pageQuery = gql`
  query BlogIndexPage($page: Int) {
    allBlogCategories {
      __typename
      id
      categoryTitle
      slug
    }
    allBlogPosts(page: $page) {
      page
      pages
      hasNext
      hasPrev
      edges: objects {
        __typename
        id
        title
        date
        preview
        image {
          url
          width
          height
        }
        url
      }
    }
  }
`;
